import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import styles from "../component/placeholder.module.scss";

export const CustomerProfilePage = () => {
	return (
		<UtilityPageLayout title="Customer Profile">
			<div className={styles.placeholderContainer}>
				<h2 className={styles.title}>Customer Profile</h2>
				<p className={styles.description}>
					View and manage detailed customer profile information including personal details,
					contact information, and account preferences.
				</p>
				<div className={styles.comingSoon}>Coming Soon</div>
			</div>
		</UtilityPageLayout>
	);
};
